<script>
import { toPng } from 'html-to-image';


import InfoCard from "./components/InfoCard.vue";
import WaterAlerts from "./components/WaterAlerts.vue";
import TideCard from "./components/TideCard.vue";
import LocationSelector from "./components/LocationSelector.vue";

import { isTouchDevice } from './utils/misc-utils';

export default {
  name: "App",
  components: {
    TideCard,
    InfoCard,
    WaterAlerts,
    LocationSelector
  },
   created: function () {

      console.log('👋@briggsrogers');
      //Get Cookie
      try {
        let previousLocation = localStorage.getItem("ht-loc");
        let loc = JSON.parse(previousLocation);

        if(loc.name){
           this.handleLocationUpdate(loc);
        }
       
      } catch (error) {
        console.log('No previous loc');
      }
  },
  data() {
    return {
      isInfoCardVisible: false,
      isNotesOverlayVisible: false,
      inspectMode: false,
      isTouchDevice: isTouchDevice(),
      hintText: isTouchDevice() ? 'Swipe up for more' : 'Calendar and locations',
      selectedLocation: {
        name : 'Seapoint',
        latlng: [53.340948, -6.163901] //Dublin
      },
      isKofiVisible: false,
      activeTab: null
    }
  },
  methods: {
    toggleinspectmode() {
      this.inspectMode = !this.inspectMode;
    },
    toggleinfocard() {
      this.isInfoCardVisible = !this.isInfoCardVisible;
    },
    toggleNotesOverlay() {
      this.isNotesOverlayVisible = !this.isNotesOverlayVisible;
    },
    handleLocationUpdate(newObject) {
      //Set Cookie
      localStorage.setItem("ht-loc", JSON.stringify(newObject));
      // eslint-disable-next-line no-undef
      gtag('event', 
        `Selected Location: ${this.selectedLocation.name}`, 
          {
            'event_category': 'Locations'
          }
        );
      
      this.selectedLocation = newObject;
    },
    async saveimage(){
      let node = document.getElementById('TideCard');

      // eslint-disable-next-line no-undef
      gtag('event', 
        `Calendar Download: ${this.selectedLocation.name}`, 
          {
            'event_category': 'Downloads'
          }
        );

      toPng(node)
      .then(function (dataUrl) {
        const link = document.createElement('a')
        link.download = 'tide-calendar.png'
        link.href = dataUrl
        link.click()
      });
    },
    toggleKofi() {
      this.isKofiVisible = !this.isKofiVisible;
    },
    setActiveTab(tab) {
      this.activeTab = this.activeTab === tab ? null : tab;
    }
  }
}
</script>

<template>

    <div class="TitleContainerOuter">
      <div class="Title" v-on:click=toggleNotesOverlay >High Tides</div>
      <!-- <div class="SubTitle">celebrates 1 year!</div> -->

    </div>
        
    <div class="CalendarContainer">
      
      <TideCard 
        v-bind:location="selectedLocation" 
        v-bind:inspectMode="inspectMode" 
        v-on:click="toggleinspectmode"
        @toggle-notes="toggleNotesOverlay" 
        @toggle-inspect="toggleinspectmode"/>
 
    </div>
    
    <div class="BottomTray" v-bind:data-inspectmode="inspectMode">
      <LocationSelector @update-location="handleLocationUpdate"/>
      <div class="SaveButtonContainer">
        <button v-on:click=saveimage></button>
      </div>
    </div>

    <div class="FooterHint" v-if="!inspectMode" v-on:click="toggleinspectmode">
      <img src="./assets/images/chevron.svg" alt="">
      <span>{{hintText}}</span>
    </div>


    <div class="TopRightContainer">
      <div class="TabNav">
        <button 
          class="TabButton" 
          :class="{ 'active': activeTab === 'alerts' }"
          :data-alerts="true"
          @click="setActiveTab('alerts')">
          Water Alerts
        </button>
        <button 
          class="TabButton" 
          :class="{ 'active': activeTab === 'info' }"
          @click="setActiveTab('info')">
          About
        </button>
      </div>
    </div>

    <WaterAlerts v-if="activeTab === 'alerts'" />
    <InfoCard v-if="activeTab === 'info'" v-bind:data-togg="isInfoCardVisible" v-on:click="toggleinfocard"/>

    <div class="KofiTray" :class="{ 'is-visible': isKofiVisible }" v-if="!inspectMode">
      <div class="KofiHeader">
        <p>High Tides turns 5! 🎂  <a href="#" @click.prevent="toggleKofi">Support the project here.</a></p>
      </div>  
      <button class="KofiClose" @click="toggleKofi" v-if="isKofiVisible">&times;</button>
      <iframe 
        id='kofiframe' 
        src='https://ko-fi.com/hightides/?hidefeed=true&widget=true&embed=true&preview=true' 
        style='border:none;width:100%;' 
        height='712' 
        title='hightides'>
      </iframe>
    </div>

</template>

<style lang="scss">
//Recoleta
@font-face {
  font-family: "recoletablack";
  src: url("assets/fonts/recoleta-black-webfont.woff2") format("woff2"),
    url("assets/fonts/recoleta-black-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

//Poppins 
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');

body{
  margin: 0;
  --main-bg: #12708b;
  --bg-secondary: #98c2c7;
  --yellow: #FDBE12;
  --text-secondary: #EAE0D3;
  --light-grey: #d0c2ad;
  --mid-grey: #616161;
  --off-white: #EAE0D3;
  --mid-blue: #81b4bb;
  --dark-blue: #0F303F;

  background-color: var(--off-white);

  display: flex;
  align-content: center;
  justify-content: center;

}

#app {
  font-family: "recoletablack";
  text-align: left;
  padding: 0;

  display: flex;
  position: relative;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;

  background-color: var(--bg-secondary);
  
  width: 100%; 
  height: 100vh;
  min-height: 550px;

  overflow: hidden;

  color: var(--light-grey);

box-shadow:
  0 1.3px 3.4px rgba(0, 0, 0, 0.047),
  0 3.4px 8.7px rgba(0, 0, 0, 0.067),
  0 6.9px 17.7px rgba(0, 0, 0, 0.083),
  0 14.2px 36.5px rgba(0, 0, 0, 0.103),
  0 39px 100px rgba(0, 0, 0, 0.15)
;

  .NotesWrapper{
    pointer-events: auto;
  }

  .TitleContainerOuter{
    position: absolute;
    top: 9vh;
    width: 100%;
   
    text-align: center; 
 

    .Title{
      color: var(--off-white); 
      font-size: 42px; 
      letter-spacing: -.5px;
      line-height: 40px;
    }
    .SubTitle{
      font-size: 16px;
      color: var(--off-white);
      
    }
  }

  .BottomTray{

    transition: transform .3s ease-in-out;

    //Hidden unless in inspect mode
    &[data-inspectmode="false"]{ 
      //pointer-events: none;
      transform: translateY(200px);
    }

    &[data-inspectmode="true"]{
      transform: translateY(0);
    }

    width: calc(100% - 20px);
    max-width: 400px;

    border-radius: 12px;

    background-color: rgba(255,255,255,.06);
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-content: space-between;

    position: absolute;
    bottom: 16px;

    box-shadow:
      0 12.5px 10px rgba(0, 0, 0, 0.035),
      0 100px 80px rgba(0, 0, 0, 0.07)
    ;

  .SaveButtonContainer{

      button{
        position: relative;
        border: none;
        background-image: url('assets/images/dl.svg');
        background-repeat: no-repeat;
        background-size: 38%;
        background-position: center;
        background-color: var(--yellow);
        height: 50px;
        width: 50px;
        border-radius: 50%;
        outline: none;
        margin: 22px;

        &:active{
          transform: scale(.97);
        }
      }
    }
  }

  .TopRightContainer {
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 1000;

    .TabNav {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .TabButton {
      font-family: 'Poppins', sans-serif;
      font-size: 12px;
      padding: 8px 16px;
      border-radius: 20px;
      border: none;
      background: var(--off-white);
      color: var(--dark-blue);
      cursor: pointer;
      transition: all 0.2s ease;
      opacity: 0.9;
      position: relative;  // Add this to position the dot

      // &[data-alerts="true"]::after {
      //   content: '';
      //   position: absolute;
      //   top: -3px;
      //   right: -3px;
      //   width: 14px;
      //   height: 14px;
      //   background-color: var(--yellow);
      //   border-radius: 50%;
      // }

      &:active {
        transform: scale(0.97);
      }

      &.active {
        opacity: 1;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
    }
  }

  .FooterHint{
    width: 100%;
    position: absolute;
    bottom: 115px;
    height: 50px;

    font-family: 'Poppins', sans-serif;
    font-size: 12px;

    color: var(--mid-blue);

    display: flex;
    flex-direction: column;

    justify-content: center;
    align-items: center;
    text-align: center;

    cursor: pointer;

    img{
      width: 30px;
      height: 20px;
      margin-bottom: 5px;
      animation: pop 2s infinite ease-in-out;

      @keyframes pop {
        50%{
          transform: translateY(-3px);
        }
      }
    }
  }

  .KofiTray {
    position: fixed;
    bottom: -720px; // Start below viewport
    left: 0;
    right: 0;
    background: white;

    margin-top: 10px;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;

    .KofiHeader{
      background-color: white;
      font-family: 'Poppins', sans-serif;
      font-size: 12px;
      color: var(--dark-blue);
      text-align: center;
      padding-top: 12px;
      padding-bottom: 12px;
    }

    a{ 
      color: var(--dark-blue);
      text-decoration: underline;
    }
    
    &.is-visible {
      transform: translateY(-720px);
    }
  }
  
  .KofiClose {
    position: absolute;
    top: 15px;
    right: 15px;
    background: var(--bg-secondary);
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    font-size: 20px;
    color: white;
    cursor: pointer;
    
    &:hover {
      opacity: 0.8;
    }
  }
  
}
</style>
